import React from 'react';
import { Tabs } from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import { useSelector } from 'react-redux';
import Custom from './custom';
import Daily from './daily';
import Requests from './requests';

const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
  <Sticky bottomOffset={80}>
    {({ style }) => (
      <DefaultTabBar
        {...props}
        className="site-custom-tab-bar color-primary"
        style={{ ...style }}
      />
    )}
  </Sticky>
);

function Index() {
  const { company } = useSelector((state) => state.auth);
  return (
    <React.Fragment>
      <h3 className="mb-3">Timesheets</h3>
      <StickyContainer>
        <Tabs defaultActiveKey="1" renderTabBar={renderTabBar} size="large">
          {company?.timesheetApproval && (
            <TabPane tab="Requests" key="1">
              <Requests />
            </TabPane>
          )}
          <TabPane tab="Daily" key="2">
            <Daily />
          </TabPane>
          <TabPane tab="Custom" key="3">
            <Custom />
          </TabPane>
        </Tabs>
      </StickyContainer>
    </React.Fragment>
  );
}

export default Index;
